<div class="modal-header">
    <h2
        class="modal-title"
        id="exampleModalLabel">
        Delete Assigned resumé
    </h2>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">Are you sure you want to delete this assigned resume?</div>

<div class="modal-footer">
    <button
        class="button button--danger"
        (click)="deleteAssignedResume()">
        Delete
    </button>
    <button
        type="button"
        class="button button--outline"
        (click)="activeModal.close()">
        Cancel
    </button>
</div>
